import {
    AuthOTPState,  AuthOTPAction, ADD_USERNAME, ADD_SECURITY_CODE
} from "./types";

const initialStateAuth: AuthOTPState = {
  identification: '',
  otp: '',
}
export function authOTPReducer(
  state = initialStateAuth,
  action: AuthOTPAction
): AuthOTPState {
  switch (action.type) {
    case ADD_USERNAME:
        return {
          ...state,
          identification: action.payload
      };
     case ADD_SECURITY_CODE:
        return {
          ...state,
          otp: action.payload
        };
    default:
      return state;
  }
}


